<div class="card">
  <div class="card__header">
    <h3 class="card__header-title">Subtotals</h3>
    <p class="card__header-price">
      {{ subtotal() | formattedCurrency: 0 }}
    </p>
  </div>

  <div class="card__content">
    <div class="card__content-prices prices">
      <ul class="prices__list">
        @for (field of fields(); track $index) {
          <li class="prices__list-item price">
            <div class="price__content">
              <span class="price__content-name">{{ field.name }}</span>
              <span class="price__content-value">
                {{ field.value | formattedCurrency: 0 }}
              </span>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="card__footer">
    <span class="card__footer-key">Total</span>
    <span class="card__footer-value">
      {{ total() | formattedCurrency: 0 }}
    </span>
  </div>
</div>
